// Story
// When user gets the Proof Store email, they get redirected back to Homepage after login instead of the proof store link they came from.
// Once the coach steps on the collection in the proof stage he should see modal pop up with some text that you have to login to see your collection.
// After login he will be redirected to that collection.

const COLLECTION_REDIRECT_KEY='teamProofStoreCollection';
const domain = window.location.origin;

document.addEventListener('DOMContentLoaded', () => {
    handleModal();
    handleRedirect();
});

function handleModal() {
  const modal = document.getElementById('team-modal');
  const modalBackdrop = document.getElementById('team-modal-backdrop');
  const modalButton = document.getElementById('team-modal-button');
  const collectionUrl = window.location.pathname;

  if (modal) {
      modal.classList.add('open');
      modalBackdrop.style.display = 'block';

      modalBackdrop.addEventListener('click', () => {
        modal.classList.remove('open');
        modalBackdrop.style.display = 'none';
      });

      modalButton.addEventListener('click', () => {
          localStorage.setItem(COLLECTION_REDIRECT_KEY, collectionUrl);

          window.location.href = domain + '/account/login';
      });
  }
}

function handleRedirect() {
    const redirectUrlCash = localStorage.getItem(COLLECTION_REDIRECT_KEY);

    if (redirectUrlCash) {
        localStorage.removeItem(COLLECTION_REDIRECT_KEY);
        const domain = window.location.origin;
        const collectionUrl = `${domain}${redirectUrlCash}`;

        window.location.href = collectionUrl;
    }
}